/* eslint-disable */
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  StyledTableCell,
  StyledTableRow,
  useStyles,
} from "../../../components/profiles/ProfileStyles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { green } from "@material-ui/core/colors";
import RedoIcon from "@material-ui/icons/Redo";
import Edit from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { compareStrings } from "utils/sort/strings";
import { createContent } from "utils/tables/createContent";

const useStyles1 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    flexGrow: 1,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5),
  },
}));

var id = [];
var idObject = [];
id.pop();
idObject.pop();

function desc(a, b, orderBy) {
  if (a[orderBy] === null || a[orderBy] === undefined) {
    a[orderBy] = "";
  }
  if (b[orderBy] === null || b[orderBy] === undefined) {
    b[orderBy] = "";
  }

  if (a[orderBy] === true) return 1;
  if (b[orderBy] === false) return -1;

  return compareStrings(a[orderBy].toString(), b[orderBy].toString());
}

const CustomPaginationActionsTable = props => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState({});
  const [rowsLength, setRowsLength] = useState(0);
  const [headers, setHeaders] = useState([]);
  const [mainField, setMainField] = useState("");
  const [visibleHeaders, setVisibleHeaders] = useState([]);
  const [sortedFields, setSortedFields] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("software");
  const [checked, setchecked] = useState(0);
  const [context, setContext] = useState("");

  React.useEffect(() => {
    setHeaders(props.headers);
    setRows(props.rows);
    setRowsLength(props.rows.length);
    setMainField(props.mainField);
    setVisibleHeaders(props.visibleHeaders);
    setSortedFields(props.sortedFields);
    setContext(props.context);
  }, [props.headers, props.mainField, props.rows, props.visibleHeaders]);

  React.useEffect(() => {
    submit();
  }, [props.type]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === sortedFields[property] && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(sortedFields[property]);
  };

  const UsersTableHead = props => {
    const { order, orderBy, onRequestSort } = props;
    const [t] = useTranslation();
    const paginationTop = action => e => {
      var selector = "[aria-label^='" + action + "']";
      document.querySelector(selector).click();
      e.preventDefault();
    };
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {visibleHeaders.map((header, index) => (
            <StyledTableCell
              key={index}
              size="small"
              align="left"
              sortDirection={orderBy === sortedFields[index] ? order : false}
            >
              <TableSortLabel
                active={orderBy === sortedFields[index]}
                direction={order}
                onClick={createSortHandler(index)}
              >
                {header.toUpperCase()}
                {orderBy === sortedFields[index] ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  var idCurrentOfPage = [];
  var listIds = [];

  UsersTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  var verify = false;
  function verifyIsChecked(idVerify) {
    idCurrentOfPage.push(idVerify);
    for (var i in idCurrentOfPage) {
      for (var j in id) {
        if (idCurrentOfPage[i] == id[j]) {
          listIds.push(idCurrentOfPage[i]);
        }
      }
    }
    verify = listIds.includes(idVerify);
  }

  let userschecked = new Object();

  function handleSwitch(e) {
    var contains = id.includes(e.target.value);
    if (contains) {
      id = id.filter(el => el !== e.target.value);
      idObject = idObject.filter(el => el.id != e.target.value);
      props.setSoftwaresOrEquipmentSelected(idObject);
    } else {
      id.push(e.target.value);
      userschecked = rows.filter(el => el.id == e.target.value);
      idObject.push(userschecked[0]);
      props.setSoftwaresOrEquipmentSelected(userschecked);
    }
  }

  const submit = () => {
    if (id.length !== 0) {
      //Limpar os arrays
      while (listIds.length) {
        listIds.pop();
      }
      while (idObject.length) {
        idObject.pop();
      }
      while (id.length) {
        id.pop();
      }
      while (idCurrentOfPage.length) {
        idCurrentOfPage.pop();
      }
      props.setSoftwaresOrEquipmentSelected([]);
    }
  };

  function change() {
    setchecked(Math.random() * 1000);
  }

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} size="small">
          {rows.length > 0 && (
            <UsersTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
          )}
          <TableBody>
            {createContent(rows, headers, order, orderBy, desc)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <StyledTableRow key={row.id + checked}>
                  {props.type === "return_of_software" && (
                    <React.Fragment>
                      <TableCell size="small">{row["software"]}</TableCell>
                      <TableCell size="small">{row["category"]}</TableCell>
                      <TableCell size="small">
                        {row["key"]
                          ? row["key"]
                          : row["email"]
                          ? row["email"]
                          : "-"}
                      </TableCell>
                      <TableCell size="small">{row["machine"]}</TableCell>
                      <TableCell size="small">
                        {row["newResponsible"] && (
                          <React.Fragment>
                            {row["newResponsible"]}
                            <CheckCircleIcon style={{ color: green[500] }} />
                          </React.Fragment>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["newStatus"] && (
                          <React.Fragment>
                            {row["newStatus"]}
                            <CheckCircleIcon style={{ color: green[500] }} />
                          </React.Fragment>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["newMachine"] && (
                          <React.Fragment>
                            {row["newMachine"]}
                            <CheckCircleIcon style={{ color: green[500] }} />
                          </React.Fragment>
                        )}
                      </TableCell>
                      <TableCell size="small">
                        {row["returned"] ? "Sim" : "Não"}
                      </TableCell>
                      {context === "edit" && (
                        <React.Fragment>
                          <TableCell size="small" align="right">
                            <div
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                                display: "flex",
                                flexWrap: "nowrap ",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Tooltip
                                title={"limpar"}
                                aria-label="details"
                                placement="top"
                              >
                                <IconButton
                                  className={classes.icons}
                                  onClick={() =>
                                    props.setRemoveIdReturnSoftware(row["id"])
                                  }
                                >
                                  <RedoIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </TableCell>
                          <TableCell size="small">
                            <Tooltip
                              title="Editar"
                              aria-label="Editar"
                              placement="top"
                            >
                              <IconButton
                                className={classes.icons}
                                onClick={() =>
                                  props.setEditReturnSoftware({
                                    open: true,
                                    obj: row,
                                  })
                                }
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                  {props.type === "use_of_software" && (
                    <React.Fragment>
                      <TableCell size="small">{row["software"]}</TableCell>
                      <TableCell size="small">{row["category"]}</TableCell>
                      <TableCell size="small">
                        {row["newMachine"] ? row["newMachine"] : ""}
                      </TableCell>
                      <TableCell size="small">
                        {row["codigo"] ? row["codigo"] : "-"}
                      </TableCell>
                      <TableCell size="small">
                        {row["keyOrEmail"] ? row["keyOrEmail"] : "-"}
                      </TableCell>
                      <TableCell size="small">
                        {row["newStatus"] && (
                          <React.Fragment>
                            {row["newStatus"]}
                            <CheckCircleIcon style={{ color: green[500] }} />
                          </React.Fragment>
                        )}
                      </TableCell>
                      {context === "edit" && (
                        <React.Fragment>
                          {row["keyOrEmail"] ? (
                            <TableCell size="small" align="right">
                              <div
                                style={{
                                  marginTop: "auto",
                                  marginBottom: "auto",
                                  display: "flex",
                                  flexWrap: "nowrap ",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Tooltip
                                  title={"limpar"}
                                  aria-label="details"
                                  placement="top"
                                >
                                  <IconButton
                                    className={classes.icons}
                                    onClick={() =>
                                      props.setRemoveIdUseSoftware(row["id"])
                                    }
                                  >
                                    <RedoIcon />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </TableCell>
                          ) : (
                            <TableCell size="small" align="right"></TableCell>
                          )}
                          <TableCell size="small">
                            <Tooltip
                              title="Editar"
                              aria-label="Editar"
                              placement="top"
                            >
                              <IconButton
                                className={classes.icons}
                                onClick={() =>
                                  props.setEditUseSoftware({
                                    open: true,
                                    obj: row,
                                  })
                                }
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
        {rows.length > 0 && (
          <TableFooter style={{ float: "right" }}>
            <TablePagination
              labelRowsPerPage={"Resultados por página"}
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              component="div"
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              //ActionsComponent={TablePaginationActions}
            />
          </TableFooter>
        )}
      </div>
    </Paper>
  );
};

CustomPaginationActionsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  visibleHeaders: PropTypes.array.isRequired,
  mainField: PropTypes.string.isRequired,
};

export default CustomPaginationActionsTable;
